export default __webpack_public_path__ + "static/HeroSectionLeft_us-0d8956f7f209b41c408a1769cac0a7b2.png";